// Workspace branding — the ONE logo-upload implementation.
//
// Both services/workspaces.service.uploadLogo and the builder's
// brandingService.uploadLogo now delegate to `uploadWorkspaceLogo` here,
// keeping their own signatures + response shapes for their callers.

import api from '@/services/api'
import type { AxiosResponse } from 'axios'

export interface LogoUploadResponse {
  file: { url: string; filename: string }
  variant: string
  message: string
}

/**
 * Upload a workspace logo for the given variant.
 * POST /save-logo/:workspaceId (multipart form data).
 *   variant: 'light' (default, colored-for-light-bg) | 'dark' (light-ink-for-dark-bg)
 */
export function uploadWorkspaceLogo(
  workspaceId: string | number,
  file: File,
  variant: 'light' | 'dark' = 'light',
): Promise<AxiosResponse<LogoUploadResponse>> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('variant', variant)
  return api.post<LogoUploadResponse>(`/private/save-logo/${workspaceId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
